import { ChatAdjustmentCTA } from '@demind-inc/core/dist/types';
import { isEmpty } from 'lodash';

export const hasCtasAdjustment = (ctas: (ChatAdjustmentCTA | undefined)[]) => {
  return ctas.some((cta) =>
    hasCtaAdjustment(cta)
  );
};

export const hasCtaAdjustment = (cta?: ChatAdjustmentCTA) => {
  if (!cta) {
    return false;
  }

  return (
    cta.meals?.length ||
    !isEmpty(cta.sleep) ||
    cta.schedule?.length ||
    cta.tasks?.length ||
    cta.routines?.length
  );
};
